export default __webpack_public_path__ + "static/media/chatbubbles-outline.c1217374.svg";